import { localeFormatter, preFormatter } from '../../../utils/formatters';

export const rulesColumns = [
  {
    dataField: 'name',
    text: 'rules.name',
    headerClassName: 'mv-350',
    disableSort: true,
  },
  {
    dataField: 'rule_type',
    text: 'rules.rule_type',
    headerClassName: 'mv-150',
    disableSort: true,
    formatter: t => localeFormatter('rules.type', t),
  },
  {
    dataField: 'rule_units',
    text: 'rules.rule_units',
    disableSort: true,
    headerClassName: 'mv-150',
    // formatter: t => (t || []).join(', '),
    formatter: t => localeFormatter('rules.units', t),
  },
  {
    dataField: 'vehicle_types',
    text: 'rules.vehicle_types',
    headerClassName: 'mv-150',
    disableSort: true,
    formatter: t => (t || []).map(vt => localeFormatter('vehicle.types', vt)).join(', '),
    // formatter: t => (t || []).join(', '),
  },
  {
    dataField: 'propulsion_types',
    text: 'rules.propulsion_types',
    headerClassName: 'mv-250',
    disableSort: true,
    formatter: t => (t || []).map(vt => localeFormatter('propulsion.types', vt)).join(', '),
  },
  {
    dataField: 'minimum',
    text: 'rules.minimum',
    disableSort: true,
  },
  {
    dataField: 'maximum',
    text: 'rules.maximum',
    disableSort: true,
  },
  {
    dataField: 'inclusive_minimum',
    text: 'rules.inclusive_minimum.short',
    disableSort: true,
    formatter: t => (t ? 'Да' : 'Нет'),
  },
  {
    dataField: 'inclusive_maximum',
    text: 'rules.inclusive_maximum.short',
    disableSort: true,
    formatter: t => (t ? 'Да' : 'Нет'),
  },
  {
    dataField: 'rate_amount',
    text: 'rules.rate_amount',
    disableSort: true,
  },
  {
    dataField: 'rate_recurrence',
    text: 'rules.rate_recurrence',
    disableSort: true,
    headerClassName: 'mv-250',
    formatter: t => localeFormatter('rate.recurrences', t),
  },
  {
    dataField: 'rate_applies_when',
    text: 'rules.rate_applies_when',
    disableSort: true,
    headerClassName: 'mv-250',
    formatter: t => localeFormatter('rate.applies.when', t),
  },
  {
    dataField: 'start_time',
    text: 'rules.start_time',
    headerClassName: 'mv-100',
    disableSort: true,
  },
  {
    dataField: 'end_time',
    text: 'rules.end_time',
    headerClassName: 'mv-100',
    disableSort: true,
  },
  {
    dataField: 'days',
    text: 'rules.days',
    disableSort: true,
    headerClassName: 'mv-150',
    formatter: t => (t || []).map(vt => localeFormatter('days', vt)).join(', '),
  },
  {
    dataField: 'value_url',
    text: 'rules.value_url',
    disableSort: true,
  },
];

export const rulesAdditionalColumns = [
  {
    dataField: 'geographies',
    text: 'rules.geographies',
    headerClassName: 'mv-350',
    disableSort: true,
    formatter: t => (t || []).join(', '),
  },
  {
    dataField: 'states',
    text: 'rules.states',
    headerClassName: 'mv-200',
    disableSort: true,
    formatter: t => preFormatter(JSON.stringify(t)),
  },
  {
    dataField: 'message',
    text: 'rules.messages',
    disableSort: true,
    headerClassName: 'mv-250',
    formatter: t => preFormatter(t || ''),
  },
];
